import data from './_data';
import components from './_components';
import methods from './_methods';
import mixins from './_mixins-missmatch-monitor';

export default {
    name: 'MismatchMonitor',
    mixins: [mixins],
    components,
    data,
    mounted() {
        // Cuando se pulsa sobre Actualizar desde RD
        this.$root.$on('showModalUpdateFromRd', show => {
            if (show) {
                this.$bvModal.show('modalUpdateFromRd');
            } else {
                this.$bvModal.hide('modalUpdateFromRd');
            }
        });

        // Se recibe la información obtenida una vez ha terminado la actualización de RD
        this.$root.$on('showUpdateResume', resume => {
            this.resume = resume;
        });

        // Añadimos la nueva pestaña de cuenta y le ponemos el flag active
        // Desactivamos el resto de pestañas para poner el foco en la última abierta
        this.$root.$on('openAccountInTab', item => this.pushTab('account', item));
        this.$root.$on('openDayInTab', item => this.pushTab('date', item));
        this.$root.$on('openKeyProductInTab', item => this.pushTab('keyProduct', item));
        this.$root.$on('refreshMonitor', () => this.fetchData());

        this.fetchData();
    },
    beforeDestroy() {
        this.$root.$off('showModalUpdateFromRd');
        this.$root.$off('showUpdateResume');
        this.$root.$off('openAccountInTab');
        this.$root.$off('openDayInTab');
        this.$root.$off('openKeyProductInTab');
        this.$root.$off('refreshMonitor');
    },
    methods,
    watch: {
        indexTabActive(val) {
            localStorage.setItem('MONITOR-TAB-ACTIVE', val);
        }
    }
};
